import React from "react";
import { useEffect } from "react";
import LogPinjam from "../../components/Pinjam/LogPeminjam";

const History = () => {
  useEffect(() => {
    document.title = "Si TASIK - Riwayat Peminjam";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <LogPinjam/>
    </div>
  );
};

export default History;
